import fetchApi from "ui-io/fetch-api";
import { UserCodec, UserT } from "./user-profile-query";

type UpdateUserRequestT = {
  userData: UserT;
  userId: string;
};

export const updateUserProfile = (updateReqObj: UpdateUserRequestT) => {
  const { userData, userId } = updateReqObj;
  return fetchApi({
    service: "user-service",
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    pathname: `/update-user-profile/${userId}`,
    codec: UserCodec,
    body: userData,
  });
};
